import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { DentureDetailsStore, DentureDetailsState } from './denture-details.store';
import { Observable } from 'rxjs';
import { ShadeSystem } from '@shared/models/shade-system';
import { IdName } from '@shared/models/id-name';
import type { Maybe } from '@/types/globals';

@Injectable({ providedIn: 'root' })
export class DentureDetailsQuery extends Query<DentureDetailsState> {
	shadeSystem$: Observable<Maybe<ShadeSystem>> = this.select(state => state.shadeSystem);
	isDentureCopyScan$: Observable<boolean> = this.select(state => state.isDentureCopyScan);
	isUpperJawChecked$: Observable<boolean> = this.select(state => state.isUpperJawChecked);
	isLowerJawChecked$: Observable<boolean> = this.select(state => state.isLowerJawChecked);

	get shadeSystem(): Maybe<ShadeSystem> {
		return this.getValue().shadeSystem;
	}

	get teethShade(): Maybe<string> {
		return this.getValue().teethShade;
	}

	get gingival(): Maybe<IdName> {
		return this.getValue().gingivalShade;
	}

	constructor(protected store: DentureDetailsStore) {
		super(store);
	}
}
